import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

import { MatButton, MatIconButton } from '@angular/material/button';

@Component({
    selector: 'app-pagina-datos-tabla',
    templateUrl: './pagina-datos-tabla.component.html',
    styleUrls: ['./pagina-datos-tabla.component.scss'],
    imports: [MatButton, MatIconButton]
})
export class PaginaDatosTablaComponent {
  @Input() totalLength = 0;
  @Input() rangeButton = 3;
  @Input() showFisrtLastButton = false;
  @Input() showPreviousButton = false;
  @Input() showLegends = true;
  @Input() registerPerPage = 5;
  public pageCurrent = 1;
  public totalPages = 0;
  public pageStart = 0;
  public pageEnd = 0;
  public rangePerPage: number[] = [];

  @Output() eventPaginator = new EventEmitter<{ pageStart: number, pageEnd: number, currentPage?: number, total?: number }>();

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.builPaginator();
  }

  private builPaginator() {
    if (!this.totalLength || !this.registerPerPage) return null;
    const div = this.totalLength / this.registerPerPage;
    this.totalPages = Math.ceil(div);
    this.pageStart = 1;
    const finReg = this.registerPerPage;
    this.pageEnd = finReg > this.totalLength ? this.totalLength : finReg;
    this.pageCurrent = 1;
    this.handleRangePerPage(); // Actualiza los rangos de páginas
    this.eventPaginator.emit({ pageStart: this.pageStart, pageEnd: this.pageEnd, currentPage: this.pageCurrent, total: this.totalPages })
  }

  public nextPage() {
    if (this.pageCurrent >= this.totalPages) return;
    this.pageCurrent = +1;
    this.pageStart = ((this.pageCurrent - 1) * this.registerPerPage) + 1;
    this.pageEnd = this.pageCurrent * this.registerPerPage;
    this.handleRangePerPage(); // Actualiza los rangos de páginas
  }

  public handleRangePerPage() {
    this.rangePerPage = [];
    let rangeStart = Math.max(1, this.pageCurrent - 1);
    let rangeEnd = Math.min(rangeStart + this.rangeButton, this.totalPages);

    for (let i = rangeStart; i <= rangeEnd; i++) {
      this.rangePerPage.push(i);
    }
  }

  public changePage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.pageCurrent = page;
    this.executeActionPaginator('handleConfigPaginator');
  }

  public handleConfigPaginator() {
    this.pageStart = ((this.pageCurrent - 1) * this.registerPerPage) + 1;
    this.pageEnd = Math.min(this.pageCurrent * this.registerPerPage, this.totalLength);
    this.handleRangePerPage(); // Actualiza los rangos de páginas
    this.eventPaginator.emit({ pageStart: this.pageStart, pageEnd: this.pageEnd, currentPage: this.pageCurrent, total: this.totalPages });
  }

  public executeActionPaginator(action: string) {
    if (!action) return;
    const acc = {
      goFirst: () => {
        if (this.pageCurrent === 1) return;
        this.pageCurrent = 1;
        acc.handleConfigPaginator();
      },
      goPrevious: () => {
        if (this.pageCurrent === 1) return;
        this.pageCurrent = this.pageCurrent - 1;
        acc.handleConfigPaginator();
      },
      goNext: () => {
        if (this.pageCurrent >= this.totalPages) return;
        this.pageCurrent = this.pageCurrent + 1;
        acc.handleConfigPaginator();
      },
      handleConfigPaginator: () => {
        this.pageStart = ((this.pageCurrent - 1) * this.registerPerPage) + 1;
        this.pageEnd = this.pageCurrent * this.registerPerPage;
        this.handleRangePerPage(); // Actualiza los rangos de páginas
        this.eventPaginator.emit({ pageStart: this.pageStart, pageEnd: this.pageEnd, currentPage: this.pageCurrent, total: this.totalPages })
      },
      goLast: () => {
        if (this.pageCurrent >= this.totalPages) return;
        this.pageCurrent = this.totalPages;
        acc.handleConfigPaginator();
      }
    };
    if (!Object.keys(acc).includes(action)) return console.log('No existe la acción::', action);
    acc[action]();
  }
}
